export default {
  trialEnabled: process.env.REACT_APP_TRIAL_ENABLED === "true",
  trialWhitelist: process.env.REACT_APP_TRIAL_WHITELIST === "true"
}